import {SPAN_KIND_CLIENT, SPAN_LEVEL_FINE} from '../constants';

export default function getSpanOptions(host, level = SPAN_LEVEL_FINE) {
	return {
		attributes: {
			tagName: host.tagName?.toLowerCase(),
			componentId: host.nowId,
			'seismic.level': level,
			kind: SPAN_KIND_CLIENT
		}
	};
}
